import { resolveApiUrl } from "./apiBase";

// Backwards-compatible exports used across the codebase
export const API_BASE = resolveApiUrl();

const API_URL = API_BASE;
export default API_URL;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

// Feature flag: toggle Todo backend integration on/off
export const TODO_BACKEND_ENABLED = true; // set to true to use backend, false for localStorage
